var _templateObject, _templateObject2, _templateObject3, _templateObject4;
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _readOnlyError(r) { throw new TypeError('"' + r + '" is read-only'); }
function _taggedTemplateLiteral(e, t) { return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, { raw: { value: Object.freeze(t) } })); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
// Simple caching for constant-radius points.
var cacheDigits, cacheAppend, cacheRadius, cacheCircle;
var PathString = /*#__PURE__*/function () {
  function PathString(digits) {
    _classCallCheck(this, PathString);
    this._append = digits == null ? append : appendRound(digits);
    this._radius = 4.5;
    this._ = "";
  }
  return _createClass(PathString, [{
    key: "pointRadius",
    value: function pointRadius(_) {
      this._radius = +_;
      return this;
    }
  }, {
    key: "polygonStart",
    value: function polygonStart() {
      this._line = 0;
    }
  }, {
    key: "polygonEnd",
    value: function polygonEnd() {
      this._line = NaN;
    }
  }, {
    key: "lineStart",
    value: function lineStart() {
      this._point = 0;
    }
  }, {
    key: "lineEnd",
    value: function lineEnd() {
      if (this._line === 0) this._ += "Z";
      this._point = NaN;
    }
  }, {
    key: "point",
    value: function point(x, y) {
      switch (this._point) {
        case 0:
          {
            this._append(_templateObject || (_templateObject = _taggedTemplateLiteral(["M", ",", ""])), x, y);
            this._point = 1;
            break;
          }
        case 1:
          {
            this._append(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["L", ",", ""])), x, y);
            break;
          }
        default:
          {
            this._append(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["M", ",", ""])), x, y);
            if (this._radius !== cacheRadius || this._append !== cacheAppend) {
              var r = this._radius;
              var s = this._;
              this._ = ""; // stash the old string so we can cache the circle path fragment
              this._append(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["m0,", "a", ",", " 0 1,1 0,", "a", ",", " 0 1,1 0,", "z"])), r, r, r, -2 * r, r, r, 2 * r);
              cacheRadius = r;
              cacheAppend = this._append;
              cacheCircle = this._;
              this._ = s;
            }
            this._ += cacheCircle;
            break;
          }
      }
    }
  }, {
    key: "result",
    value: function result() {
      var result = this._;
      this._ = "";
      return result.length ? result : null;
    }
  }]);
}();
export { PathString as default };
function append(strings) {
  var i = 1;
  this._ += strings[0];
  for (var j = strings.length; i < j; ++i) {
    this._ += arguments[i] + strings[i];
  }
}
function appendRound(digits) {
  var d = Math.floor(digits);
  if (!(d >= 0)) throw new RangeError("invalid digits: ".concat(digits));
  if (d > 15) return append;
  if (d !== cacheDigits) {
    var k = Math.pow(10, d);
    cacheDigits = d;
    cacheAppend = function append(strings) {
      var i = 1;
      this._ += strings[0];
      for (var j = strings.length; i < j; ++i) {
        this._ += Math.round(arguments[i] * k) / k + strings[i];
      }
    };
  }
  return cacheAppend;
}